"use client"

import { Fragment, useState, useEffect } from "react"
import { useAppSelector } from "../../ReduxToolkit/Hooks"
import { H6, LI } from "../../AbstractElements"
import { subscribeToMenuChanges, getMenuState, subscribeToMenuUpdates } from "../../Data/Layout/Sidebar"
import type { MenuItem } from "../../Types/Layout/Sidebar"
import MenuLists from "./MenuLists"
import { useTranslation } from "react-i18next"

const SidebarMenuList = () => {
  const [activeMenu, setActiveMenu] = useState<string[]>([])
  const [menuState, setMenuState] = useState(getMenuState())
  const [, forceUpdate] = useState({})
  const { t } = useTranslation()
  const { pinedMenu } = useAppSelector((state) => state.layout)

  const shouldHideMenu = (mainMenu: MenuItem) => {
    return mainMenu?.Items?.map((data) => data.title).every((titles) => pinedMenu.includes(titles || ""))
  }

  // Subscribe to menu state changes
  useEffect(() => {
    // Subscribe to menu state changes
    const unsubscribe1 = subscribeToMenuChanges(() => {
      setMenuState(getMenuState())
    })

    // Subscribe to real-time menu updates
    const unsubscribe2 = subscribeToMenuUpdates(() => {
      setMenuState(getMenuState())
      forceUpdate({}) // Force component re-render
    })

    // Cleanup subscriptions on unmount
    return () => {
      unsubscribe1()
      unsubscribe2()
    }
  }, [])

  // Show loading state
  if (menuState.isLoading && menuState.menuList.length === 0) {
    return (
      <LI className="sidebar-main-title">
        <div>
          <H6>
            <i className="fa fa-spinner fa-spin me-2"></i>
            {t("Loading menu...")}
          </H6>
        </div>
      </LI>
    )
  }

  // Show error state
  if (menuState.error && menuState.menuList.length === 0) {
    return (
      <LI className="sidebar-main-title">
        <div>
          <H6 className="text-danger">
            <i className="fa fa-exclamation-triangle me-2"></i>
            {t("Error loading menu")}
          </H6>
        </div>
      </LI>
    )
  }

  // Show authentication required state
  if (!menuState.isAuthenticated) {
    return (
      <LI className="sidebar-main-title">
        <div>
          <H6>
            <i className="fa fa-lock me-2"></i>
            {t("Please log in")}
          </H6>
        </div>
      </LI>
    )
  }

  return (
    <>
      {menuState.menuList &&
        menuState.menuList.map((mainMenu: MenuItem, index) => (
          <Fragment key={index}>
            <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
              <div>
                <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
              </div>
            </LI>
            <MenuLists menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={0} />
          </Fragment>
        ))}
    </>
  )
}

export default SidebarMenuList
